import { cn } from "@/utils";
import { ExternalLink } from "lucide-react";

/**
 * Inline "Open" pill rendered at the tail of a list row, just before the
 * kebab — the workspace detail list view's open affordance. Hidden until row
 * hover (the enclosing `group`) so it doesn't add visual noise at rest; it
 * lives in the row's reserved actions column, so revealing it never shifts
 * the layout.
 */
export function RowOpenPill({
  onOpen,
  label,
}: {
  onOpen: () => void;
  /** Resource name — labels the button for assistive tech. */
  label: string;
}) {
  return (
    <button
      type="button"
      aria-label={`Open ${label}`}
      className={cn(
        "inline-flex h-7 cursor-pointer items-center gap-1 rounded-full px-2.5 text-xs font-medium transition-opacity",
        "bg-foreground/[0.08] text-foreground/80 hover:bg-foreground/[0.14] hover:text-foreground",
        "dark:bg-n-95/[0.08] dark:hover:bg-n-95/[0.14]",
        "opacity-0 focus-visible:opacity-100 group-hover:opacity-100",
      )}
      onClick={(e) => {
        e.stopPropagation();
        onOpen();
      }}
      // A fast second click must not bubble a double-click open to the row.
      onDoubleClick={(e) => e.stopPropagation()}
    >
      <ExternalLink className="h-3 w-3" />
      Open
    </button>
  );
}
